import React from 'react';
import '../styles/Alert.css';

const Alert = ({ type = 'info', message, onClose }) => {
  console.log('🔔 Alert rendering:', { type, message });
  if (!message) {
    console.log('🔔 Alert skipping - no message');
    return null;
  }

  const alertStyles = {
    success: {
      backgroundColor: '#d4edda',
      borderColor: '#c3e6cb',
      color: '#155724',
      icon: '✓'
    },
    error: {
      backgroundColor: '#f8d7da',
      borderColor: '#f5c6cb',
      color: '#721c24',
      icon: '✕'
    },
    warning: {
      backgroundColor: '#fff3cd',
      borderColor: '#ffeeba',
      color: '#856404',
      icon: '⚠'
    },
    info: {
      backgroundColor: '#d1ecf1',
      borderColor: '#bee5eb',
      color: '#0c5460',
      icon: 'ℹ'
    }
  };

  const style = alertStyles[type] || alertStyles.info;

  return (
    <div 
      className="alert-container"
      style={{
        backgroundColor: style.backgroundColor,
        borderColor: style.borderColor,
        color: style.color,
        border: `2px solid ${style.borderColor}`,
        padding: '16px 20px',
        borderRadius: '8px',
        marginBottom: '20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '15px',
        fontWeight: '500',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        animation: 'slideIn 0.3s ease-out',
        position: 'relative',
        zIndex: 1000,
        width: '100%',
        boxSizing: 'border-box'
      }}
      role="alert"
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <span style={{ fontSize: '20px', fontWeight: 'bold' }}>{style.icon}</span>
        <span>{message}</span>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: style.color,
            fontSize: '20px',
            cursor: 'pointer',
            padding: '0 4px',
            opacity: 0.7
          }}
          aria-label="Close alert"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Alert;
